export default __webpack_public_path__ + "images/08dc721fabb7f7e1a4be7adfc07afc70.webp";